import * as turf from "@turf/turf";
import commonCard from "../assets/images/cards/common-card.png";
import visaCard from "../assets/images/cards/visa-card.png";
import masterCard from "../assets/images/cards/master-card.png";
import americanExpressCard from "../assets/images/cards/american-express-card.png";
import jcbCard from "../assets/images/cards/jcb-card.png";
import unionPayCard from "../assets/images/cards/union-pay-card.png";
import dinersClubCard from "../assets/images/cards/diners-club-card.png";
import discoverCard from "../assets/images/cards/discover-card.png";

const southwest = [-125.00165, 24.9493];
const northeast = [-66.9326, 49.5904];

export const RestrictedMapBbox = [
  -179.9, // southwest longitude (covers all of Alaska & Hawaii)
  18.0, // southwest latitude  (south of Hawaii)
  -65.0, // northeast longitude (east coast)
  72.0, // northeast latitude  (north of Alaska)
];

export const centerOfUSA = [-73.916016, 40.780508];
export const centerOfMap = [-98.5795, 39.8283];
export const centerOfCanada = [-96.0, 61.5];

export const CanadaRestrictedMapBbox = [
  -141.0, // SW longitude: Westernmost point in Yukon (Canada)
  41.7, // SW latitude: Southern Canada border (excludes US Great Lakes region)
  -52.6, // NE longitude: Easternmost point of Newfoundland (Canada)
  83.5, // NE latitude: Northern boundary including Arctic islands
];

// Combined bounds for users with both USA and Canada access
export const BothCountriesMapBbox = [
  -179.0, // SW longitude (covers Alaska + Hawaii + Yukon)
  18.0, // SW latitude (south of Hawaii & continental US)
  -52.0, // NE longitude (eastern Newfoundland)
  83.7, // NE latitude (northernmost Canadian islands)
];

// centerOfSaskatchewan = [-106.3468, 52.9399]; // [longitude, latitude]

export const mapRoadLayer = [
  {
    title: "Highways",
    disable: false,
    values: [
      {
        id: "highway-layer",
        title: "Highway Layer",
        disable: false,
      },
      // {
      //   id: "road-motorway-trunk",
      //   title: "Road Motorway Trunk",
      //   disable: false,
      // },
    ],
  },
  {
    title: "Road network, surface",
    disable: false,
    values: [
      //   {
      //     id: "road-exit-shield",
      //     title: "Road Minor Link",
      //     disable: false,
      //   },
      //   {
      //     id: "road-motorway-trunk-case",
      //     title: "Road Minor Link",
      //     disable: false,
      //   },
      //   {
      //     id: "road-major-link-case",
      //     title: "Road Minor Link",
      //     disable: false,
      //   },
      //   {
      //     id: "road-secondary-tertiary-case",
      //     title: "Road Minor Link",
      //     disable: false,
      //   },
      //   {
      //     id: "road-minor-link-case",
      //     title: "Road Minor Link",
      //     disable: false,
      //   },
      //   {
      //     id: "road-street-case",
      //     title: "Road Minor Link",
      //     disable: false,
      //   },
      //   {
      //     id: "road-minor-case",
      //     title: "Road Minor Link",
      //     disable: false,
      //   },
      //   {
      //     id: "road-number-shield",
      //     title: "Road Minor Link",
      //     disable: false,
      //   },
      //   {
      //     id: "road-intersection",
      //     title: "Road Minor Link",
      //     disable: false,
      //   },
      //   {
      //     id: "road-street-low",
      //     title: "Road Street Low",
      //     disable: false,
      //   },
      //   {
      //     id: "road-steps",
      //     title: "Road Minor Link",
      //     disable: false,
      //   },
      // {
      //   id: "road-minor-link",
      //   title: "Road Minor Link",
      //   disable: false,
      // },
      {
        id: "road-primary-case",
        title: "Road Primary Case",
        disable: false,
      },
      // {
      //   id: "road-minor",
      //   title: "Road Minor",
      //   disable: false,
      // },
      // {
      //   id: "road-major-link",
      //   title: "Road Major Link",
      //   disable: false,
      // },
      {
        id: "road-street",
        title: "Road Street",
        disable: false,
      },
      {
        id: "road-secondary-tertiary",
        title: "Road Secondary Tertiary",
        disable: false,
      },
      {
        id: "road-primary",
        title: "Road Primary",
        disable: false,
      },
      {
        id: "road-label",
        title: "Road Label",
        disable: false,
      },
    ],
  },
];

export const mapFeatureLayer = [
  {
    title: "Place labels, place-labels",
    disable: false,
    values: [
      {
        id: "settlement-subdivision-label",
        title: "Settlement Subdivision Label",
        disable: false,
      },
      {
        id: "continent-label",
        title: "Continent Label",
        disable: false,
      },
    ],
  },
  {
    title: "Point of interest labels, poi-labels",
    disable: false,
    values: [
      {
        id: "poi-label",
        title: "Poi Label",
        disable: false,
      },
    ],
  },
  {
    title: "Buildings, building-labels",
    disable: false,
    values: [
      {
        id: "building-number-label",
        title: "Building Number Label",
        disable: false,
      },
    ],
  },
  {
    title: "Buildings, built",
    disable: false,
    values: [
      {
        id: "building",
        title: "Building",
        disable: false,
      },
    ],
  },
  {
    title: "Land & water",
    disable: false,
    values: [
      {
        id: "land-structure-polygon",
        title: "Land Structure Polygon",
        disable: false,
      },
      {
        id: "land-structure-line",
        title: "Land Structure Line",
        disable: false,
      },
    ],
  },
  {
    title: "Land & water, land",
    disable: false,
    values: [
      {
        id: "national-park",
        title: "National Park",
        disable: false,
      },
    ],
  },
  {
    title: "Land & water, water",
    disable: false,
    values: [
      {
        id: "waterway",
        title: "Waterway",
        disable: false,
      },
    ],
  },
  {
    title: "Transit, transit-labels",
    disable: false,
    values: [
      {
        id: "transit-label",
        title: "Transit Label",
        disable: false,
      },
      {
        id: "airport-label",
        title: "Airport Label",
        disable: false,
      },
    ],
  },
  {
    title: "Walking, cycling, etc., surface",
    disable: false,
    values: [
      {
        id: "road-path",
        title: "Road Path",
        disable: false,
      },
      {
        id: "road-pedestrian",
        title: "Road Pedestrian",
        disable: false,
      },
      {
        id: "golf-hole-line",
        title: "Golf Hole Line",
        disable: false,
      },
    ],
  },
  {
    title: "Walking, cycling, etc., walking-cycling-labels",
    disable: false,
    values: [
      {
        id: "golf-hole-label",
        title: "Golf Hole Label",
        disable: false,
      },
    ],
  },
];

export const colorSchemeData = [
  [
    "#E65100",
    "#F57C00",
    "#FB8C00",
    "#FFA000",
    "#FBC02D",
    "#FDD835",
    "#C0CA33",
    "#AFB42B",
    "#9CCC65",
    "#8BC34A",
    "#7CB342",
    "#AED581",
    "#E6EE9C",
  ],
  [
    "#0D47A1",
    "#1565C0",
    "#1976D2",
    "#1E88E5",
    "#2196F3",
    "#42A5F5",
    "#64B5F6",
    "#4FC3F7",
    "#81D4FA",
    "#90CAF9",
    "#BBDEFB",
    "#B3E5FC",
    "#E3F2FD",
  ],
  [
    "#B71C1C",
    "#C62828",
    "#D32F2F",
    "#E53935",
    "#F44336",
    "#EF5350",
    "#FF5252",
    "#E57373",
    "#FF8A80",
    "#EF9A9A",
    "#FFCDD2",
    "#F5E2E5",
    "#FFEBEE",
  ],
  [
    "#1B5E20",
    "#2E7D32",
    "#388E3C",
    "#43A047",
    "#4CAF50",
    "#66BB6A",
    "#81C784",
    "#A5D6A7",
    "#AED581",
    "#C5E1A5",
    "#C8E6C9",
    "#DCEDC8",
    "#F1F8E9",
  ],
  [
    "#F44336",
    "#FF5722",
    "#FF9800",
    "#FFC107",
    "#FFEB3B",
    "#CDDC39",
    "#8BC34A",
    "#4CAF50",
    "#009688",
    "#00BCD4",
    "#03A9F4",
    "#2196F3",
    "#B3E5FC",
  ],
  [
    "#4A148C",
    "#6A1B9A",
    "#7E57C2",
    "#9575CD",
    "#AB47BC",
    "#BA68C8",
    "#CE93D8",
    "#B39DDB",
    "#4DB6AC",
    "#80CBC4",
    "#B2DFDB",
    "#c2ecf2",
    "#E0F7FA",
  ],
];

export const gradeRangesDefaultData = [
  { color: "#E65100", value: "500", id: "GradeF", grade: "F" },
  { color: "#F57C00", value: "300", id: "GradeDMinus", grade: "D-" },
  { color: "#FB8C00", value: "250", id: "GradeD", grade: "D" },
  { color: "#FFA000", value: "200", id: "GradeDPlus", grade: "D+" },
  { color: "#FBC02D", value: "175", id: "GradeCMinus", grade: "C-" },
  { color: "#FDD835", value: "150", id: "GradeC", grade: "C" },
  { color: "#C0CA33", value: "125", id: "GradeCPlus", grade: "C+" },
  { color: "#AFB42B", value: "100", id: "GradeBMinus", grade: "B-" },
  { color: "#9CCC65", value: "75", id: "GradeB", grade: "B" },
  { color: "#8BC34A", value: "60", id: "GradeBPlus", grade: "B+" },
  { color: "#7CB342", value: "50", id: "GradeAMinus", grade: "A-" },
  { color: "#AED581", value: "40", id: "GradeA", grade: "A" },
  { color: "#E6EE9C", value: "39", id: "GradeAPlus", grade: "A+" },
];

export const defaultColorScheme = [
  "#E81416",
  "#FFA500",
  "#FAEB36",
  "#79C314",
  "#487DE7",
  "#70369D",
];

export const legendData = [
  { color: "#FF5733", value: "150", range: "or More" },
  { color: "#FFC300", value: "100", range: "to 150" },
  { color: "#28B463", value: "80", range: "to 100" },
  { color: "#3498DB", value: "80", range: "or Less" },
];

export const MapSourceLayer = {
  continents: {
    path: `${process.env.REACT_APP_TILESERVER_URL}/data/continents/{z}/{x}/{y}.pbf`,
    layerFilterInitialStr: "usa_cn_premium_crimerisk",
    sourceLayer: "blocks",
  },
  blocks: {
    path: `${process.env.REACT_APP_TILESERVER_URL}/data/blocks/{z}/{x}/{y}.pbf`,
    layerFilterInitialStr: "usa_bl_premium_crimerisk",
    sourceLayer: "blocks",
  },
  blockGroups: {
    path: `${process.env.REACT_APP_TILESERVER_URL}/data/blockgroups/{z}/{x}/{y}.pbf`,
    layerFilterInitialStr: "usa_bn_premium_crimerisk",
    sourceLayer: "blocks",
  },
  envBlockGroups: {
    path: `${process.env.REACT_APP_TILESERVER_URL}/data/envblockgroups/{z}/{x}/{y}.pbf`,
    layerFilterInitialStr: "usa_bn_premium_environment",
    sourceLayer: "blocks",
  },
  envContinents: {
    path: `${process.env.REACT_APP_TILESERVER_URL}/data/envcontinents/{z}/{x}/{y}.pbf`,
    layerFilterInitialStr: "usa_cn_premium_environment",
    sourceLayer: "blocks",
  },
  FS: {
    path: `${process.env.REACT_APP_TILESERVER_URL}/data/canadafsa/{z}/{x}/{y}.pbf`,
    layerFilterInitialStr: "can_fs_crimerisk",
    sourceLayer: "blocks",
  },
  DA: {
    path: `${process.env.REACT_APP_TILESERVER_URL}/data/canadadisarea/{z}/{x}/{y}.pbf`,
    layerFilterInitialStr: "can_da_crimerisk",
    sourceLayer: "blocks",
  },
};

export const defaultCrimeRiskLayerData = [
  { color: "#E81416", value: "251", id: "crimeRange1" },
  { color: "#FFA500", value: "201", id: "crimeRange2" },
  { color: "#FAEB36", value: "151", id: "crimeRange3" },
  { color: "#79C314", value: "100", id: "crimeRange4" },
  { color: "#487DE7", value: "50", id: "crimeRange5" },
  { color: "#70369D", value: "49", id: "crimeRange6" },
];

export const ENV_RISK_VALUE_STEP = 0.1;

export const formatEnvRiskValue = (value) => Number(value).toFixed(1);

export const getEnvRangeUpperBound = (upperValue) =>
  (Number(upperValue) - ENV_RISK_VALUE_STEP).toFixed(1);

export const normalizeEnvLegendValues = (legendData) =>
  legendData.map((item) => ({
    ...item,
    value: formatEnvRiskValue(item.value),
  }));

export const defaultEnvRiskLayerData = [
  { color: "#E81416", value: "3.0", id: "environmentRange1" },
  { color: "#E81416", value: "2.5", id: "environmentRange1" },
  { color: "#FFA500", value: "2.0", id: "environmentRange2" },
  { color: "#FAEB36", value: "1.5", id: "environmentRange3" },
  { color: "#79C314", value: "1.0", id: "environmentRange4" },
  { color: "#487DE7", value: "0.9", id: "environmentRange5" },
];

export const rangeDefaultValues = {
  high: [1500, 1000, 800, 500, 400, 399],
  medium: [800, 600, 500, 400, 300, 299],
  low: [600, 500, 400, 300, 200, 199],
};

export const crimeRiskLayer = [
  {
    id: "CRMCYTOTC",
    title: "Total Crime",
    disable: false,
  },
  {
    id: "CRMCYPERC",
    title: "Personal Crime",
    disable: false,
  },
  {
    id: "CRMCYMURD",
    title: "Murder",
    disable: false,
  },
  {
    id: "CRMCYROBB",
    title: "Robbery",
    disable: false,
  },
  {
    id: "CRMCYRAPE",
    title: "Rape",
    disable: false,
  },
  {
    id: "CRMCYASST",
    title: "Assault",
    disable: false,
  },
  {
    id: "CRMCYPROC",
    title: "Property Crime",
    disable: false,
  },
  {
    id: "CRMCYBURG",
    title: "Burglary",
    disable: false,
  },
  {
    id: "CRMCYLARC",
    title: "Larceny",
    disable: false,
  },
  {
    id: "CRMCYMVEH",
    title: "Motor Vehicle Theft",
    disable: false,
  },
];

export const environmentalRiskLayer = [
  {
    id: "NRKWRSKI",
    title: "Weather Risk Scale Index 0-10",
    disable: false,
  },
  {
    id: "NRKHURI",
    title: "Hurricance Risk Scale Index 0-10",
    disable: false,
  },
  {
    id: "NRKTORI",
    title: "Tornado Risk Scale Index 0-10",
    disable: false,
  },
  {
    id: "NRKHAILI",
    title: "Hail Risk Scale Index 0-10",
    disable: false,
  },
  {
    id: "NRKWINDI",
    title: "Wind Risk Scale Index 0-10",
    disable: false,
  },
  {
    id: "NRKWFRI",
    title: "Wildfire Risk Scale Index 0-10",
    disable: false,
  },
  {
    id: "NRKQUKI",
    title: "Quake Risk Scale Index 0-10",
    disable: false,
  },
  {
    id: "NRKSEALVLI",
    title: "Sea Level Scale Index 0-10",
    disable: false,
  },
  {
    id: "NRKSTMSGI",
    title: "Storm Surge Risk Scale Index 0-10",
    disable: false,
  },
  {
    id: "NRKTSNMI",
    title: "Tsunami Risk Scale Index 0-10",
    disable: false,
  },
];

export const MapLayoutWidth = 425;

export const MaximumLTA = 100;

export const MaxImageCount = 1000;

export const NearestDistance = 50; // Replace with your minimum distance threshold

export const RadiusTypeEnum = {
  RADIUS_RING: "radius-ring",
  DRIVE_TIME: "drive-time",
};

export const RadiusReportEnum = {
  RING_REPORT: "ring_report",
  POLYGON_REPORT: "polygon_report",
  DRIVE_TIME_REPORT: "drive_time_report",
};

export const DefaultValues = {
  defaultShapeSetting: {
    addShapeToMapFlag: false,
    selectedShape: null,
    addSelectedShapeFlag: null,
  },
};

export const CountryList = [
  { id: "AF", name: "Afghanistan" },
  { id: "AX", name: "Åland Islands" },
  { id: "AL", name: "Albania" },
  { id: "DZ", name: "Algeria" },
  { id: "AS", name: "American Samoa" },
  { id: "AD", name: "Andorra" },
  { id: "AO", name: "Angola" },
  { id: "AI", name: "Anguilla" },
  { id: "AQ", name: "Antarctica" },
  { id: "AG", name: "Antigua and Barbuda" },
  { id: "AR", name: "Argentina" },
  { id: "AM", name: "Armenia" },
  { id: "AW", name: "Aruba" },
  { id: "AU", name: "Australia" },
  { id: "AT", name: "Austria" },
  { id: "AZ", name: "Azerbaijan" },
  { id: "BS", name: "Bahamas" },
  { id: "BH", name: "Bahrain" },
  { id: "BD", name: "Bangladesh" },
  { id: "BB", name: "Barbados" },
  { id: "BY", name: "Belarus" },
  { id: "BE", name: "Belgium" },
  { id: "BZ", name: "Belize" },
  { id: "BJ", name: "Benin" },
  { id: "BM", name: "Bermuda" },
  { id: "BT", name: "Bhutan" },
  { id: "BO", name: "Bolivia (Plurinational State of)" },
  { id: "BQ", name: "Bonaire, Sint Eustatius and Saba" },
  { id: "BA", name: "Bosnia and Herzegovina" },
  { id: "BW", name: "Botswana" },
  { id: "BV", name: "Bouvet Island" },
  { id: "BR", name: "Brazil" },
  { id: "IO", name: "British Indian Ocean Territory" },
  { id: "BN", name: "Brunei Darussalam" },
  { id: "BG", name: "Bulgaria" },
  { id: "BF", name: "Burkina Faso" },
  { id: "BI", name: "Burundi" },
  { id: "CV", name: "Cabo Verde" },
  { id: "KH", name: "Cambodia" },
  { id: "CM", name: "Cameroon" },
  { id: "CA", name: "Canada" },
  { id: "KY", name: "Cayman Islands" },
  { id: "CF", name: "Central African Republic" },
  { id: "TD", name: "Chad" },
  { id: "CL", name: "Chile" },
  { id: "CN", name: "China" },
  { id: "CX", name: "Christmas Island" },
  { id: "CC", name: "Cocos (Keeling) Islands" },
  { id: "CO", name: "Colombia" },
  { id: "KM", name: "Comoros" },
  { id: "CG", name: "Congo" },
  { id: "CD", name: "Congo (Democratic Republic of the)" },
  { id: "CK", name: "Cook Islands" },
  { id: "CR", name: "Costa Rica" },
  { id: "CI", name: "Côte d'Ivoire" },
  { id: "HR", name: "Croatia" },
  { id: "CU", name: "Cuba" },
  { id: "CW", name: "Curaçao" },
  { id: "CY", name: "Cyprus" },
  { id: "CZ", name: "Czech Republic" },
  { id: "DK", name: "Denmark" },
  { id: "DJ", name: "Djibouti" },
  { id: "DM", name: "Dominica" },
  { id: "DO", name: "Dominican Republic" },
  { id: "EC", name: "Ecuador" },
  { id: "EG", name: "Egypt" },
  { id: "SV", name: "El Salvador" },
  { id: "GQ", name: "Equatorial Guinea" },
  { id: "ER", name: "Eritrea" },
  { id: "EE", name: "Estonia" },
  { id: "ET", name: "Ethiopia" },
  { id: "FK", name: "Falkland Islands (Malvinas)" },
  { id: "FO", name: "Faroe Islands" },
  { id: "FJ", name: "Fiji" },
  { id: "FI", name: "Finland" },
  { id: "FR", name: "France" },
  { id: "GF", name: "French Guiana" },
  { id: "PF", name: "French Polynesia" },
  { id: "TF", name: "French Southern Territories" },
  { id: "GA", name: "Gabon" },
  { id: "GM", name: "Gambia" },
  { id: "GE", name: "Georgia" },
  { id: "DE", name: "Germany" },
  { id: "GH", name: "Ghana" },
  { id: "GI", name: "Gibraltar" },
  { id: "GR", name: "Greece" },
  { id: "GL", name: "Greenland" },
  { id: "GD", name: "Grenada" },
  { id: "GP", name: "Guadeloupe" },
  { id: "GU", name: "Guam" },
  { id: "GT", name: "Guatemala" },
  { id: "GG", name: "Guernsey" },
  { id: "GN", name: "Guinea" },
  { id: "GW", name: "Guinea-Bissau" },
  { id: "GY", name: "Guyana" },
  { id: "HT", name: "Haiti" },
  { id: "HM", name: "Heard Island and McDonald Islands" },
  { id: "VA", name: "Holy See" },
  { id: "HN", name: "Honduras" },
  { id: "HK", name: "Hong Kong" },
  { id: "HU", name: "Hungary" },
  { id: "IS", name: "Iceland" },
  { id: "IN", name: "India" },
  { id: "ID", name: "Indonesia" },
  { id: "IR", name: "Iran (Islamic Republic of)" },
  { id: "IQ", name: "Iraq" },
  { id: "IE", name: "Ireland" },
  { id: "IM", name: "Isle of Man" },
  { id: "IL", name: "Israel" },
  { id: "IT", name: "Italy" },
  { id: "JM", name: "Jamaica" },
  { id: "JP", name: "Japan" },
  { id: "JE", name: "Jersey" },
  { id: "JO", name: "Jordan" },
  { id: "KZ", name: "Kazakhstan" },
  { id: "KE", name: "Kenya" },
  { id: "KI", name: "Kiribati" },
  { id: "KP", name: "Korea (Democratic People's Republic of)" },
  { id: "KR", name: "Korea (Republic of)" },
  { id: "KW", name: "Kuwait" },
  { id: "KG", name: "Kyrgyzstan" },
  { id: "LA", name: "Lao People's Democratic Republic" },
  { id: "LV", name: "Latvia" },
  { id: "LB", name: "Lebanon" },
  { id: "LS", name: "Lesotho" },
  { id: "LR", name: "Liberia" },
  { id: "LY", name: "Libya" },
  { id: "LI", name: "Liechtenstein" },
  { id: "LT", name: "Lithuania" },
  { id: "LU", name: "Luxembourg" },
  { id: "MO", name: "Macao" },
  { id: "MK", name: "Macedonia (the former Yugoslav Republic of)" },
  { id: "MG", name: "Madagascar" },
  { id: "MW", name: "Malawi" },
  { id: "MY", name: "Malaysia" },
  { id: "MV", name: "Maldives" },
  { id: "ML", name: "Mali" },
  { id: "MT", name: "Malta" },
  { id: "MH", name: "Marshall Islands" },
  { id: "MQ", name: "Martinique" },
  { id: "MR", name: "Mauritania" },
  { id: "MU", name: "Mauritius" },
  { id: "YT", name: "Mayotte" },
  { id: "MX", name: "Mexico" },
  { id: "FM", name: "Micronesia (Federated States of)" },
  { id: "MD", name: "Moldova (Republic of)" },
  { id: "MC", name: "Monaco" },
  { id: "MN", name: "Mongolia" },
  { id: "ME", name: "Montenegro" },
  { id: "MS", name: "Montserrat" },
  { id: "MA", name: "Morocco" },
  { id: "MZ", name: "Mozambique" },
  { id: "MM", name: "Myanmar" },
  { id: "NA", name: "Namibia" },
  { id: "NR", name: "Nauru" },
  { id: "NP", name: "Nepal" },
  { id: "NL", name: "Netherlands" },
  { id: "NC", name: "New Caledonia" },
  { id: "NZ", name: "New Zealand" },
  { id: "NI", name: "Nicaragua" },
  { id: "NE", name: "Niger" },
  { id: "NG", name: "Nigeria" },
  { id: "NU", name: "Niue" },
  { id: "NF", name: "Norfolk Island" },
  { id: "MP", name: "Northern Mariana Islands" },
  { id: "NO", name: "Norway" },
  { id: "OM", name: "Oman" },
  { id: "PK", name: "Pakistan" },
  { id: "PW", name: "Palau" },
  { id: "PS", name: "Palestine, State of" },
  { id: "PA", name: "Panama" },
  { id: "PG", name: "Papua New Guinea" },
  { id: "PY", name: "Paraguay" },
  { id: "PE", name: "Peru" },
  { id: "PH", name: "Philippines" },
  { id: "PN", name: "Pitcairn" },
  { id: "PL", name: "Poland" },
  { id: "PT", name: "Portugal" },
  { id: "PR", name: "Puerto Rico" },
  { id: "QA", name: "Qatar" },
  { id: "RE", name: "Réunion" },
  { id: "RO", name: "Romania" },
  { id: "RU", name: "Russian Federation" },
  { id: "RW", name: "Rwanda" },
  { id: "BL", name: "Saint Barthélemy" },
  { id: "SH", name: "Saint Helena, Ascension and Tristan da Cunha" },
  { id: "KN", name: "Saint Kitts and Nevis" },
  { id: "LC", name: "Saint Lucia" },
  { id: "MF", name: "Saint Martin (French part)" },
  { id: "PM", name: "Saint Pierre and Miquelon" },
  { id: "VC", name: "Saint Vincent and the Grenadines" },
  { id: "WS", name: "Samoa" },
  { id: "SM", name: "San Marino" },
  { id: "ST", name: "Sao Tome and Principe" },
  { id: "SA", name: "Saudi Arabia" },
  { id: "SN", name: "Senegal" },
  { id: "RS", name: "Serbia" },
  { id: "SC", name: "Seychelles" },
  { id: "SL", name: "Sierra Leone" },
  { id: "SG", name: "Singapore" },
  { id: "SX", name: "Sint Maarten (Dutch part)" },
  { id: "SK", name: "Slovakia" },
  { id: "SI", name: "Slovenia" },
  { id: "SB", name: "Solomon Islands" },
  { id: "SO", name: "Somalia" },
  { id: "ZA", name: "South Africa" },
  { id: "GS", name: "South Georgia and the South Sandwich Islands" },
  { id: "SS", name: "South Sudan" },
  { id: "ES", name: "Spain" },
  { id: "LK", name: "Sri Lanka" },
  { id: "SD", name: "Sudan" },
  { id: "SR", name: "Suriname" },
  { id: "SJ", name: "Svalbard and Jan Mayen" },
  { id: "SE", name: "Sweden" },
  { id: "CH", name: "Switzerland" },
  { id: "SY", name: "Syrian Arab Republic" },
  { id: "TW", name: "Taiwan, Province of China" },
  { id: "TJ", name: "Tajikistan" },
  { id: "TZ", name: "Tanzania, United Republic of" },
  { id: "TH", name: "Thailand" },
  { id: "TL", name: "Timor-Leste" },
  { id: "TG", name: "Togo" },
  { id: "TK", name: "Tokelau" },
  { id: "TO", name: "Tonga" },
  { id: "TT", name: "Trinidad and Tobago" },
  { id: "TN", name: "Tunisia" },
  { id: "TR", name: "Turkey" },
  { id: "TM", name: "Turkmenistan" },
  { id: "TC", name: "Turks and Caicos Islands" },
  { id: "TV", name: "Tuvalu" },
  { id: "UG", name: "Uganda" },
  { id: "UA", name: "Ukraine" },
  { id: "AE", name: "United Arab Emirates" },
  { id: "GB", name: "United Kingdom of Great Britain and Northern Ireland" },
  { id: "US", name: "United States of America" },
  { id: "UM", name: "United States Minor Outlying Islands" },
  { id: "UY", name: "Uruguay" },
  { id: "UZ", name: "Uzbekistan" },
  { id: "VU", name: "Vanuatu" },
  { id: "VE", name: "Venezuela (Bolivarian Republic of)" },
  { id: "VN", name: "Viet Nam" },
  { id: "VG", name: "Virgin Islands (British)" },
  { id: "VI", name: "Virgin Islands (U.S.)" },
  { id: "WF", name: "Wallis and Futuna" },
  { id: "EH", name: "Western Sahara" },
  { id: "YE", name: "Yemen" },
  { id: "ZM", name: "Zambia" },
  { id: "ZW", name: "Zimbabwe" },
];

export const getCenterCoordinates = (value) => {
  const polygon = turf.polygon([value[0]]);
  const centroid = turf.centroid(polygon);
  return centroid.geometry.coordinates;
};

export const Rgba2hex = (orig, hex = false) => {
  const rgb = orig
    .replace(/\s/g, "")
    .match(/^rgba?\((\d+),(\d+),(\d+),?([\d.]+)?\)$/i);

  if (!rgb) {
    throw new Error("Invalid RGB(A) color format");
  }

  const [, r, g, b, a = "1"] = rgb;
  const toHex = (n) => n.toString(16).padStart(2, "0");

  const red = toHex(parseInt(r, 10));
  const green = toHex(parseInt(g, 10));
  const blue = toHex(parseInt(b, 10));
  const alpha = toHex(Math.round(parseFloat(a) * 255));

  // Correctly parse and compare alpha as a float
  const isTransparent = parseFloat(a) < 1; // Convert 'a' to float and compare
  if (hex) {
    return `#${red}${green}${blue}`;
  }
  return `#${red}${green}${blue}${isTransparent ? alpha : ""}`;
};

export const hexToRgba = (color, opacity) => {
  if (/^rgba?\(/.test(color)) {
    const match = color.match(/^rgba?\(([^)]+)\)$/);
    if (match) {
      const rgbaValues = match[1].split(",").map((value) => value.trim());

      return `rgba(${rgbaValues[0]}, ${rgbaValues[1]}, ${rgbaValues[2]}, ${
        opacity / 100
      })`;
    }
  }

  color = color.replace(/^#/, "");

  if (color.length === 3) {
    color = color
      .split("")
      .map((c) => c + c)
      .join("");
  }

  let bigint = parseInt(color, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${opacity / 100})`;
};

export const getOpacity = (rgba) => {
  const rgbaRegex = /rgba?\(\d+,\s*\d+,\s*\d+,\s*([0-1](?:\.\d+)?)\)/;
  const match = rgba?.match(rgbaRegex);

  if (match) {
    return Math.round(parseFloat(match[1]) * 100);
  } else {
    return 100;
  }
};

export const rgbToHex = (rgbString) => {
  const result = rgbString.match(/\d+/g);
  if (result && result.length === 3) {
    const [r, g, b] = result.map(Number);
    return "#" + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1);
  }
  return "";
};

export const splitPx = (data) => {
  return data.match(/^-?\d*\.?\d+|\D+/g);
};

export const getHexFromTextShadow = (textShadow, data) => {
  // Regular expression to find the rgba or rgb part of the text-shadow string
  if (data === "color") {
    return Rgba2hex(textShadow);
  }
};

export const GetRandomBrightColor = () => {
  const hex = Math.floor(Math.random() * 0xffffff).toString(16);
  return `#${hex.padStart(6, "0")}`;
};

export const CalculatePixelDistance = (coords1, coords2) => {
  const dx = coords1.x - coords2.x;
  const dy = coords1.y - coords2.y;
  return Math.sqrt(dx * dx + dy * dy);
};

export const labelFontSize = (zoom, val, type) => {
  const zoomLevel = parseInt(zoom);
  if (type === "radius") {
    const radius = parseFloat(val);
    if (radius < 1 && radius > 0) {
      if (zoomLevel > 11 && zoomLevel < 14) {
        return "4px";
      } else if (zoomLevel >= 14 && zoomLevel < 15) {
        return "8px";
      } else if (zoomLevel >= 15 && zoomLevel < 16) {
        return "10px";
      } else if (zoomLevel >= 16) {
        return "16px";
      }
      return "0px";
    } else if (radius < 5) {
      if (zoomLevel <= 10) {
        return zoomLevel <= 10 && zoomLevel > 8 ? `${radius}px` : "0px";
      } else if (zoomLevel >= 10 && zoomLevel < 13) {
        return "10px";
      }
      return "16px";
    } else if (radius >= 5 && radius < 10) {
      if (zoomLevel <= 9 && zoomLevel > 8) {
        return "10px";
      } else if (zoomLevel <= 8) {
        return "0px";
      }
      return "16px";
    } else if (radius >= 10 && radius < 20) {
      if (zoomLevel <= 10 && zoomLevel > 8) {
        return "14px";
      } else if (zoomLevel <= 8 && zoomLevel > 7) {
        return "9px";
      } else if (zoomLevel <= 7) {
        return "0px";
      }
      return "16px";
    } else if (radius >= 20 && radius < 30) {
      if (zoomLevel <= 8 && zoomLevel > 7) {
        return "12px";
      } else if (zoomLevel <= 7) {
        return "0px";
      }
      return "16px";
    } else if (radius >= 30 && radius < 50) {
      if (zoomLevel <= 8 && zoomLevel > 7) {
        return "12px";
      } else if (zoomLevel <= 7) {
        return "0px";
      }
      return "16px";
    } else if (radius >= 50 && radius < 75) {
      if (zoomLevel <= 8 && zoomLevel > 6) {
        return "12px";
      } else if (zoomLevel <= 6) {
        return "0px";
      }
      return "16px";
    } else if (radius >= 75 && radius <= 100) {
      if (zoomLevel <= 8 && zoomLevel > 5) {
        return "12px";
      } else if (zoomLevel <= 5) {
        return "0px";
      }
      return "16px";
    }
    return "0px";
  } else {
    const mins = parseFloat(val);
    if (mins < 5 && mins >= 1) {
      if (zoomLevel > 11 && zoomLevel < 14) {
        return "6px";
      } else if (zoomLevel >= 14 && zoomLevel < 16) {
        return "9px";
      } else if (zoomLevel >= 16 && zoomLevel < 18) {
        return "13px";
      } else if (zoomLevel >= 18) {
        return "16px";
      }
      return "0px";
    } else if (mins >= 5 && mins < 15) {
      if (zoomLevel > 11 && zoomLevel < 14) {
        return "10px";
      } else if (zoomLevel >= 14 && zoomLevel < 16) {
        return "12px";
      } else if (zoomLevel >= 16 && zoomLevel < 18) {
        return "14px";
      } else if (zoomLevel >= 18) {
        return "16px";
      }
      return "0px";
    } else if (mins >= 15 && mins < 30) {
      if (zoomLevel > 10 && zoomLevel < 14) {
        return "12px";
      } else if (zoomLevel >= 14 && zoomLevel < 16) {
        return "14px";
      } else if (zoomLevel >= 16) {
        return "16px";
      }
      return "0px";
    } else if (mins >= 30 && mins < 45) {
      if (zoomLevel > 8 && zoomLevel < 14) {
        return "12px";
      } else if (zoomLevel >= 14) {
        return "16px";
      }
      return "0px";
    } else if (mins >= 45 && mins <= 60) {
      if (zoomLevel > 8 && zoomLevel < 14) {
        return "14px";
      } else if (zoomLevel >= 14) {
        return "16px";
      }
      return "0px";
    }
  }
};

export const mockTime = () => {
  const storedDate = localStorage.getItem("mockTime");
  if (storedDate) {
    return new Date(storedDate);
  } else {
    return new Date();
  }
};

export const dateToString = (date) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const parts = date.split("/");
  const month = parseInt(parts[0], 10);
  const day = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);

  const formattedDate = months[month - 1] + " " + day + ", " + year;

  return formattedDate;
};

export const GetCreditLogosByName = (brandName) => {
  const card = {
    visa: visaCard,
    mastercard: masterCard,
    jcb: jcbCard,
    discover: discoverCard,
    amex: americanExpressCard,
    unionpay: unionPayCard,
    diners: dinersClubCard,
  };

  return card[brandName] || commonCard;
};

export const DisplayErrorMessages = (err) => {
  let err_msg = "";
  let cnt = 0;
  if (err?.response?.data?.errors) {
    err.response.data.errors.forEach((errors) => {
      cnt += 1;
      err_msg += cnt + ". " + errors.msg + "\n";
    });
  } else if (err?.response?.data?.message) {
    err_msg = err.response.data.message
      ? err.response.data.message
      : "Something went wrong!";
  }
  return err_msg;
};
